export default {
    baseApiUrl: 'https://api.codegeniusacademy.com'
    // baseApiUrl: 'http://localhost:8080'
}
